import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  class: "bonusomat-progress__percentage"
}

import { computed } from "vue";

import WebpImage from "@sazka/design-system/src/image/webp-image.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'bonusomat-progress',
  props: {
    progress: {},
    isCompleted: { type: Boolean },
    showPercentageNumber: { type: Boolean },
    alwaysVisible: { type: Boolean },
    showTrackerEvenIfCompleted: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const isVisible = computed(() => {
    return (props.progress > 0 && props.progress < 100) || props.showPercentageNumber || props.alwaysVisible;
});

const progressLabel = computed(() => {
    if (isNaN(props.progress)) {
        return "";
    }

    return `${props.progress > 99 ? Math.floor(props.progress) : Math.round(props.progress)} %`;
});

const progressValue = computed(() => {
    if (isNaN(props.progress)) {
        return 1;
    }

    const min = 0;
    const max = 1;
    const value = 1 - props.progress / 100;

    return Math.min(Math.max(value, min), max);
});

return (_ctx: any,_cache: any) => {
  return (_ctx.isCompleted && !_ctx.showTrackerEvenIfCompleted)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(WebpImage, {
          class: "bonusomat-progress bonusomat-progress--img",
          src: "/frontend/web/img/casino/bonusomat/progress-done.svg",
          alt: ""
        })
      ]))
    : (isVisible.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(["bonusomat-progress-wrap", { 'bonusomat-progress__contains-percentage': _ctx.showPercentageNumber }])
        }, [
          (_openBlock(), _createElementBlock("svg", {
            class: "bonusomat-progress bonusomat-progress--rotate",
            style: _normalizeStyle(`--progress-value: ${progressValue.value}`)
          }, _cache[0] || (_cache[0] = [
            _createStaticVNode("<circle class=\"bonusomat-progress__track\"></circle><circle class=\"bonusomat-progress__value\" stroke=\"url(#value-gradient)\"></circle><defs><linearGradient id=\"value-gradient\"><stop stop-color=\"#76D911\"></stop><stop offset=\"1\" stop-color=\"#54C00C\"></stop></linearGradient></defs>", 3)
          ]), 4)),
          (_ctx.showPercentageNumber)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(progressLabel.value), 1))
            : _createCommentVNode("", true)
        ], 2))
      : _createCommentVNode("", true)
}
}

})